<template>
  <div class="stream-loader">
    <div class="pivo-logo">
      <img src="../assets/pivo.png" alt="pivo" />
    </div>
    <div class="content">
      <h1>Loading...</h1>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped lang="scss">
@keyframes rotateAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes reverseRotateAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.stream-loader {
  position: absolute;
  height: 100vh;
  width: 100%;
  background-color: #e5e5e5;
  .pivo-logo {
    position: absolute;
    top: 20px;
    left: 20px;
    img {
      height: 35px;
    }
  }
  .content {
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h1 {
      font-size: 40px;
      color: #a5adbb;
      margin-bottom: 120px;
    }
  }
  .spinner {
    position: relative;
    width: 125px;
    height: 125px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      border-width: 15px;
      border-style: solid;
      border-radius: 50%;
    }

    &:before {
      width: 140px;
      height: 140px;
      border-bottom-color: #a5adbb;
      border-right-color: #a5adbb;
      border-top-color: transparent;
      border-left-color: transparent;
      border-radius: 50%;
      animation: rotateAnimation 1.5s linear 0s infinite;
    }

    &:after {
      width: 82px;
      height: 82px;
      border-bottom-color: #a5adbb;
      border-right-color: #a5adbb;
      border-top-color: transparent;
      border-left-color: transparent;
      animation: reverseRotateAnimation 1.5s linear 0s infinite;
    }
  }
}
</style>
